import { SearchOutlined } from '@ant-design/icons';
import { Input, Select } from 'antd';
import React from 'react';
import type { DocumentFilterCondition } from '../../types';

interface ConditionKeywordInputProps {
    condition: DocumentFilterCondition;
    groupId: string;
    updateCondition: (groupId: string, conditionId: string, updates: Partial<DocumentFilterCondition>) => void;
}

type SearchType = 'condition' | 'text' | 'title' | 'procedure';

const SEARCH_TYPE_OPTIONS = [
    { label: 'Condition', value: 'condition' as SearchType, description: 'Search in condition names (vocab.concept)' },
    { label: 'Procedure', value: 'procedure' as SearchType, description: 'Search in procedure names (vocab.concept)' },
    { label: 'Text', value: 'text' as SearchType, description: 'Search in note text content' },
    { label: 'Title', value: 'title' as SearchType, description: 'Search in note titles' },
];

/**
 * Input component for condition keyword filter with search type selection
 */
export const ConditionKeywordInput: React.FC<ConditionKeywordInputProps> = ({
    condition,
    groupId,
    updateCondition,
}) => {
    const searchType = (condition as any).searchType || 'condition';

    return (
        <div className="flex w-full flex-col gap-2">
            <Select
                value={searchType}
                onChange={(value: SearchType) =>
                    updateCondition(groupId, condition.id, {
                        ...condition,
                        searchType: value,
                    } as any)
                }
                options={SEARCH_TYPE_OPTIONS}
                className="!h-[32px] !text-[12px]"
                placeholder="Select search type"
            />
            <Input
                prefix={<SearchOutlined className="text-[#8C8C8C]" />}
                placeholder={
                    searchType === 'condition'
                        ? 'e.g., diabetes, cancer'
                        : searchType === 'text'
                          ? 'e.g., search in note text'
                          : searchType === 'title'
                            ? 'e.g., search in note titles'
                            : searchType === 'procedure'
                              ? 'e.g., surgery, biopsy'
                              : 'e.g., search keyword'
                }
                value={condition.value || ''}
                onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
                    updateCondition(groupId, condition.id, {
                        value: e.target.value || undefined,
                    })
                }
                allowClear
                className="!h-[32px] !text-[12px]"
            />
        </div>
    );
};
